import { Stack, Typography } from "@mui/material";
import type { PeriodType, TabularDataCell } from "../../../../../../../api/types/svTypes.ts";
import TransitionLoader from "../common/TransitionLoader.tsx";
import TileDelta from "./TileDelta.tsx";
import { getPeriodTypeFormattedValue } from "./utils/periodTypeUtils.ts";

interface Props {
  value: TabularDataCell | undefined;
  delta: TabularDataCell | undefined;
  isLoading: boolean;
  period?: PeriodType;
}

const TilePreview = ({ value, delta, isLoading, period }: Props) => {
  return (
    <Stack useFlexGap spacing={0.5} sx={{ position: "relative" }}>
      <TransitionLoader isLoading={isLoading}>
        <Typography variant="h2">{value?.formattedValue}</Typography>
        {delta && (
          <Stack direction="row" useFlexGap spacing={0.5} sx={{ alignItems: "end" }}>
            <TileDelta delta={delta} />
            {period && (
              <Typography color="secondary" sx={{ whiteSpace: "nowrap" }}>
                {getPeriodTypeFormattedValue(period)}
              </Typography>
            )}
          </Stack>
        )}
      </TransitionLoader>
    </Stack>
  );
};
export default TilePreview;
